<template>
  <div class="animated fadeIn">
    <basic-heading title="New Analysis" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add analysis'">
      <template #gated-content>
        <analysis-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import AnalysisForm from "@/components/lab/analysis/AnalysisForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { notificationOptions } from "@/shared/toast-notification-options";
import { analysisNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const AnalysisRepository = LabRepositoryFactory.get("analysis");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "analysisAdd",
  components: {
    AnalysisForm,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/analysis",
            title: "Analysis list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(payload) {
      try {
        const { data } = await AnalysisRepository.create(payload);

        this.addSuccess();
        this.$router.push(`/analysis/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: analysisNotifications,
};
</script>
